"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JkcInput = void 0;
var JkcInput_1 = require("./JkcInput");
Object.defineProperty(exports, "JkcInput", { enumerable: true, get: function () { return __importDefault(JkcInput_1).default; } });
